const FILTER_CAT_IDS = {
    MAKEUP: 'cat140006',
    SKIN_CARE: 'cat150006',
    HAIR: 'cat130038',
    FRAGRANCE: 'cat160006',
    TOOLS: 'cat130042'
};

const FILTER_IDS = {
    AGE_RANGE: 'ageRange',
    MAKEUP: 'makeup',
    SKIN_CARE: 'skinCare',
    SKIN_TONE: 'skinTone',
    HAIR_TYPE: 'hairType',
    HAIR_DESCRIBLE: 'hairDescrible',
    HAIR_TEXTURE: 'hairTexture',
    FRAGRANCE_FAMILY: 'fragranceFamily',
    NON_INCENTIVIZED: 'nonIncentivizedReviews'
};

/**
 * Configuration for category-specific filters that should be automatically added
 * when user is on specific product category pages.
 *
 * Each config object defines:
 * - categoryId: The category where this filter should be added
 * - filterId: The ID of the filter to add (must exist in Master List)
 * - afterFilterId: The filter after which to insert the new filter
 * - excludeOptions: Array of option key patterns to exclude from filter options
 */
const CATEGORY_SPECIFIC_FILTER_CONFIGS = [
    {
        categoryId: FILTER_CAT_IDS.FRAGRANCE, // Fragrance category (cat160006)
        filterId: FILTER_IDS.FRAGRANCE_FAMILY, // Add 'fragranceFamily' filter
        afterFilterId: FILTER_IDS.NON_INCENTIVIZED, // Insert after 'nonIncentivizedReviews'
        excludeOptions: ['noPreference'] // Exclude options containing 'noPreference'
    },
    {
        categoryId: FILTER_CAT_IDS.HAIR, // Hair category (cat130038)
        filterId: FILTER_IDS.HAIR_TEXTURE, // Add 'hairTexture' filter
        afterFilterId: FILTER_IDS.HAIR_TYPE, // Insert after 'hairType'
        excludeOptions: [] // No exclusions for hair texture options
    }
];

export {
    FILTER_CAT_IDS, FILTER_IDS, CATEGORY_SPECIFIC_FILTER_CONFIGS
};
